import React from "react";
import { SURFACE, BORDER, TEXT, ACCENT } from "../constants/colors";

const STATUS_LEGEND = [
  { label: "On Track", color: ACCENT.green },
  { label: "At Risk", color: ACCENT.amber },
  { label: "Blocked", color: ACCENT.red },
];

const StatusBar = () => {
  return (
    <div
      style={{
        background: SURFACE.pageBg,
        borderTop: `1px solid ${BORDER.statusBar}`,
        padding: "0px 24px",
        display: "flex",
        alignItems: "center",
        gap: 16,
        flexShrink: 0,
      }}
    >
      <span
        style={{
          fontSize: 10,
          color: TEXT.darkest,
          fontFamily: "Poppins",
        }}
      >
        Supply Flow
      </span>
      <div style={{ display: "flex", gap: 12 }}>
        {STATUS_LEGEND.map((l) => (
          <span
            key={l.label}
            style={{
              fontSize: 10,
              color: l.color,
              display: "flex",
              alignItems: "center",
              gap: 4,
            }}
          >
            <span
              style={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                background: l.color,
                display: "inline-block",
              }}
            />
            {l.label}
          </span>
        ))}
      </div>
      <span
        style={{
          marginLeft: "auto",
          fontSize: 10,
          color: TEXT.dim,
          fontFamily: "Poppins",
        }}
      >
        Drag cards between stages · Click to expand · WIP limits enforced
      </span>
    </div>
  );
};

export default StatusBar;
